import {useCallback, useEffect, useState} from 'react';
import cx from 'classnames';
import {Categories} from './components/Categories/Categories';
import {SubCategories} from './components/SubCategories/SubCategories';
import {DrawerHeader} from './components/DrawerHeader/DrawerHeader';

import './MobileCategoryDrawer.sass';

const MAIN_CATERGORIES = 0;
const SUB_CATEGORIES = 1;

export const MobileCategoryDrawer = ({
  open,
  closeNav,
  invitationCategories,
  greetingCardCategory,
  eGiftCardCategory,
  signupSheetCategory,
}) => {
  const [level1Category, setLevel1Category] = useState(null);
  const [navLevel, setNavLevel] = useState(MAIN_CATERGORIES);

  const allCategories = [
    ...invitationCategories,
    greetingCardCategory,
    eGiftCardCategory,
    signupSheetCategory,
  ].filter(Boolean);

  useEffect(() => {
    document.body.classList.toggle('no-scroll', open);
  }, [open]);

  const navigateToCategory = useCallback((category) => {
    setLevel1Category(category);
    setNavLevel(SUB_CATEGORIES);
  }, []);

  const goBack = useCallback(() => {
    setNavLevel(MAIN_CATERGORIES);
    setTimeout(() => setLevel1Category(null), 300);
  }, [navLevel]);

  const onCloseNav = useCallback(() => {
    closeNav();
    setNavLevel(MAIN_CATERGORIES);
    setLevel1Category(null);
  }, [closeNav]);

  return (
    <div className={cx('category-drawer', {'category-drawer--open': open})}>
      <DrawerHeader showBackArrow={navLevel > 0} onGoBack={goBack} onClose={onCloseNav} />

      <div
        className={cx('category-drawer__navigation-container', {
          [`level-${navLevel}-open`]: navLevel > 0,
        })}
      >
        <div className="category-drawer__navigation-slide category-drawer__navigation-slide--main">
          <Categories
            categories={allCategories}
            open={open}
            navLevel={navLevel}
            navigateToCategory={navigateToCategory}
            setNavLevel={setNavLevel}
          />
        </div>

        <div className="category-drawer__navigation-slide category-drawer__navigation-slide--sub">
          {level1Category && (
            <SubCategories
              subCategories={level1Category.subCategories}
              open={open}
              navLevel={navLevel}
              level1Category={level1Category}
              setLevel1Category={setLevel1Category}
              setNavLevel={setNavLevel}
            />
          )}
        </div>
      </div>
    </div>
  );
};
